import { render, staticRenderFns } from "./DownPaymentRatio.vue?vue&type=template&id=a96d942e&scoped=true&"
import script from "./DownPaymentRatio.vue?vue&type=script&lang=js&"
export * from "./DownPaymentRatio.vue?vue&type=script&lang=js&"
import style0 from "./DownPaymentRatio.vue?vue&type=style&index=0&id=a96d942e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96d942e",
  null
  
)

export default component.exports